import { Switch, useRouteMatch } from 'react-router-dom';
import { TransactionDrawer } from 'assets/js/pages/transactions/TransactionDrawer';
import { TicketDrawer } from 'components/pages/tickets/TicketDrawer';
import { Route } from 'components/router/Route';

const TransactionDrawerRouter = () => {
    const match = useRouteMatch();

    return (
        <Switch>
            <Route path={`${match.path}/tickets/:ticket_id`} component={TicketDrawerRouter} />
            <Route path={match.path} component={TransactionDrawer} />
        </Switch>
    );
};

const TicketDrawerRouter = () => {
    const match = useRouteMatch();

    return (
        <Switch>
            <Route
                path={`${match.path}/transactions/:transaction_id`}
                component={TransactionDrawerRouter}
            />
            <Route path={match.path} component={TicketDrawer} />
        </Switch>
    );
};

export { TicketDrawerRouter };
